<div class="mx-auto max-w-(--breakpoint-2xl)">
  <div class="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900">
    <div class="mb-6 flex items-start justify-between gap-4">
      <div>
        <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Settings</h1>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Wording and values that can be changed without a code change or a deploy. Saving takes effect on the next page load.
        </p>
      </div>
    </div>

    @if (loading) {
      <p class="py-12 text-center text-sm text-gray-500 dark:text-gray-400">Loading…</p>
    } @else if (rows.length === 0) {
      <div class="rounded-lg border border-dashed border-gray-300 px-6 py-12 text-center dark:border-gray-700">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          No settings registered yet. Engineers register settings in <code class="font-mono">config/settings.php</code>.
        </p>
      </div>
    } @else {
      <ul class="divide-y divide-gray-200 dark:divide-gray-800">
        @for (row of rows; track row.setting.key) {
          <li class="flex flex-col gap-3 py-5" [attr.data-testid]="'setting-' + row.setting.key">
            <div class="min-w-0">
              <div class="flex flex-wrap items-center gap-2">
                <h2 class="text-base font-medium text-gray-900 dark:text-white">{{ row.setting.label }}</h2>
                <span class="font-mono text-xs text-gray-400 dark:text-gray-500">{{ row.setting.key }}</span>
              </div>
              @if (row.setting.description) {
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ row.setting.description }}</p>
              }
            </div>

            <app-textarea [control]="row.control" [name]="row.setting.key" [rows]="3"></app-textarea>

            <div class="flex flex-wrap items-center gap-3">
              <app-button
                [label]="row.saving ? 'Saving…' : 'Save'"
                [disabled]="row.saving || !isDirty(row)"
                (click)="save(row)"
              ></app-button>
              <app-button
                [label]="'Revert'"
                [style]="'secondary'"
                [disabled]="row.saving || !isDirty(row)"
                (click)="revert(row)"
              ></app-button>
              <p class="text-xs text-gray-400 dark:text-gray-500">
                Last changed: {{ formatTimestamp(row.setting.last_changed_at) }}
                @if (row.setting.last_changed_by) {
                  by {{ row.setting.last_changed_by.name }}
                }
              </p>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</div>
